import {
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Navbar from "../Pages/Navbar";
import Sidebar from "../Pages/Sidebar";
import Dashboard from "../Pages/dashboard/Dashboard";
import { useEffect } from "react";
import "../assets/js/custom";
import UserPage from "../Pages/UserPage/User";
import VideoPage from "../Pages/VideoPage/VideoPage";
import PaymentSetting2 from "../Pages/PaymentSetting";
import ChannelPage from "../Pages/Channel/ChannelPage";
import ContactUsPage from "../Pages/ContactUs";
import ShortsPage from "../Pages/Shorts/ShortsPage";
import SoundPage from "../Pages/Sound/SoundPage";
import FAQ from "../Pages/FAQ";
import Profile from "../Pages/Profile";
import PremiumPlan from "../Pages/PremiumPlan/PremiumPlan";
import UserSetting from "../Pages/UserPage/UserSetting";
import Currency from "../Pages/Currency";
import ManageSetting from "../Pages/Setting/ManageSetting";
import ManageWithDraw from "../Pages/WithDrawRequest/ManageWithDraw";
import ManageMonetization from "../Pages/MonetizationRequest/ManageMonetization";
import ManageReport from "../Pages/Report/ManageReport";
import AdminEarnings from "../Pages/AdminEarnings";
import SubAdmin from "../Pages/roleManagement/SubAdmin";
import MetricsAnalytic from "../Pages/Metrics/MetricsAnalytic";
import SubAdminDashboard from "../Pages/SubAdminDashboard";
import VideoCategory from "../Pages/VideoCategory";
import Courses from "../Pages/Courses/CoursesPage";
import OrgPage from "../Pages/Organization/OrgPage";
import OrgCourses from "../Pages/Organization/OrgCourses";
import SubscriptionsPlanPage from "../Pages/SubscriptionsPlan/SubscriptionsPlanPage";
import CouponsPage from "../Pages/Coupons/CouponsPage";
import History from "../Pages/Payments/History";

const Admin = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const role = JSON.parse(sessionStorage.getItem("admin"));

  useEffect(() => {
    if (
      location.pathname == "/" ||
      location.pathname == "/admin" ||
      location.pathname == ""
    ) {
      if (role?.isOrg) {
        navigate("/org/dashboard");
      } else {
        if (role?.isSubAdmin === false) {
          navigate("/admin/mainDashboard");
        } else {
          navigate("/admin/subdashboard");
        }
      }
    }
  }, [role]);

  return (
    <>
      <div className="mainContainer d-flex w-100">
        <div className="containerLeft">
          <Sidebar />
        </div>
        <div className="containerRight w-100 ">
          <Navbar />
          <div className="mainAdmin ml-4">
            <div className="mobSidebar-bg  d-none"></div>
            <Routes>
              <Route path="/mainDashboard" element={<Dashboard />} />
              <Route path="/userTable" element={<UserPage />} />
              <Route path="/organizations" element={<OrgPage />} />
              <Route path="/videos" element={<VideoPage />} />
              <Route path="/shorts" element={<ShortsPage />} />
              <Route path="/channel" element={<ChannelPage />} />
              <Route path="/sound" element={<SoundPage />} />
              <Route path="/paymentSetting2" element={<PaymentSetting2 />} />
              <Route path="/settingPage" element={<ManageSetting />} />
              <Route path="/allfaq" element={<FAQ />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/userProfile" element={<UserSetting />} />
              <Route path="/allreport" element={<ManageReport />} />
              <Route path="/premiumPlanTable" element={<PremiumPlan />} />
              <Route path="/contactUs" element={<ContactUsPage />} />
              <Route path="/allCurrency" element={<Currency />} />
              <Route path="/withrawRequest" element={<ManageWithDraw />} />
              <Route
                path="/allmonetizationRequest"
                element={<ManageMonetization />}
              />
              <Route path="/adminEarnings" element={<AdminEarnings />} />
              <Route path="/roleManagement" element={<SubAdmin />} />
              <Route path="/metrics" element={<MetricsAnalytic />} />
              <Route path="/subdashboard" element={<SubAdminDashboard />} />
              <Route path="/videoCategories" element={<VideoCategory />} />
              <Route path="/courses" element={<Courses />} />
              <Route
                path="/subscription-plan"
                element={<SubscriptionsPlanPage />}
              />
              <Route path="/coupon" element={<CouponsPage />} />
              <Route path="/payments" element={<History />} />

              <Route path="/organization/:id" element={<OrgCourses />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
